import styled from "styled-components";
import AppsFooter from "@lib/components/AppComponents/AppsContainer/AppsFooter";
import { darken, rgba } from "polished";
import { Layout } from "antd";

const { Sider } = Layout;

export const StyledChatContentScreen = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledChatNoScreen = styled.div`
  padding: 16px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    font-size: 20px;
  }
`;

export const StyledNoUserScreen = styled.div`
  position: relative;

  > svg {
    font-size: 3rem;
    color: ${({ theme }) => theme.palette.gray[500]};
    margin-bottom: 20px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      font-size: 5rem;
    }
  }
`;

export const StyledAddNewMessage = styled.div`
  display: flex;
`;

export const StyledNewMessageAction = styled.div`
  margin-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  [dir="rtl"] & {
    margin-left: 0;
    margin-right: 8px;
  }

  & .message-btn {
    background-color: ${({ theme }) =>
      darken(0.05, theme.palette.background.paper)};
    color: ${({ theme }) => theme.palette.text.disabled};
    border: 0 none;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.circle};
    height: 40px;
    width: 40px;
    padding: 5px;
    box-shadow: none;
    font-size: 20px;

    & .anticon-send {
      margin-left: 3px;

      [dir="rtl"] & {
        margin-left: 0;
        margin-right: 3px;
      }
    }

    & + .message-btn {
      margin-left: 10px;

      [dir="rtl"] & {
        margin-left: 0;
        margin-right: 10px;
      }
    }
  }
`;

export const StyledNewMsgActionFirst = styled(StyledNewMessageAction)`
  margin-left: 0;
  margin-right: 8px;

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 8px;
  }
`;

export const StyledChatHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & .user-info {
    width: 100%;
  }
`;
export const StyledChatHeaderAction = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  [dir="rtl"] & {
    margin-left: 0;
    margin-right: auto;
  }

  & .icon-btn {
    color: ${({ theme }) => theme.palette.text.secondary};
    background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.05)};
    margin-left: 5px;
    margin-right: 5px;

    &:hover,
    &:focus {
      background-color: ${() => rgba("black", 0.05)};
      color: ${({ theme }) => theme.palette.text.primary};
    }

    &.active {
      color: ${({ theme }) => theme.palette.primary.main};

      &:hover,
      &:focus {
        background-color: ${() => rgba("black", 0.05)};
        color: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }
`;

export const StyledMessageScreen = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MsgScrool = styled.div`
  height: calc(100% - 132px);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden !important;
  overflow-y: auto;
  white-space: normal;
  padding-top: 5px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  position: relative;
`;

export const StyledScrollChatNoMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 100%;
`;
export const StyledNoMsg = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.gray[500]};
`;
export const StyledMsgAppsFooter = styled(AppsFooter)`
  margin-top: auto;
`;

export const StyledSider = styled(Sider)`
  overflow: hidden;
  transition: width 0.3s ease;
  border-left: 1px solid ${({ theme }) => theme.palette.gray[200]};
  background: ${({ theme }: { theme: any }) =>
    theme.palette.background.paper} !important;
  color: ${({ theme }) => theme.palette.text.primary};

  & ul {
    margin: 30px 0 0;
    padding: 0;
    list-style: none;

    & li {
      margin: 10px 0;
      padding: 5px 10px;
      &:hover {
        background-color: ${({ theme }) =>
          rgba(theme.palette.primary.main, 0.05)};
      }
    }
  }

  & .close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: transparent;
    color: ${({ theme }) => theme.palette.text.secondary};

    &:hover {
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`;

export const StyledChatAlarmContainer = styled.div`
  margin-top: 30px;

  h3 {
    padding-left: 20px;
    font-size: 18px;
    font-weight: bold;
  }
`;

export const StyledAlarmList = styled.div`
  padding: 20px;
  max-height: 70vh;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => `${theme.palette.primary.main}`};
  overflow-y: auto;
`;

export const StyledAlarmCard = styled.div`
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  background: ${({ theme }) => theme.palette.background.paper};
  cursor: pointer;
`;

export const StyledLabel = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledContent = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
